export default __webpack_public_path__ + "static/media/thaigot-screenshot-05.e1644b31.png";